module.exports = __webpack_public_path__ + "static/media/notFound.6a154534.svg";